module.exports = __webpack_public_path__ + "media/images/Pin-f8d703db7bb4e47c2b7ab2b23794541e.svg";